const PURPOSE_FIELDS = {
  nadobudnutie: "suma_nadobudnutie",
  refinancovanie: "suma_refinancovanie",
  bezucel: "suma_bezucel",
};

function amount(amounts, field) {
  const value = Number(amounts?.[field] || 0);
  return Number.isFinite(value) ? Math.max(0, value) : 0;
}

function normalizePurpose(purpose) {
  switch (purpose) {
    case "suma_bezucel":
    case "americka_hypo":
    case "bezucel":
      return "bezucel";
    case "suma_refinancovanie":
    case "refinancovanie":
    case "konsolidacia":
      return "refinancovanie";
    case "suma_nadobudnutie":
    case "nadobudnutie":
    case "uverovy_certifikat":
    default:
      return "nadobudnutie";
  }
}

function getMortgagePurposeField(amounts = {}, fallbackPurpose = null, options = {}) {
  const acquisition = amount(amounts, PURPOSE_FIELDS.nadobudnutie);
  const refinancing = amount(amounts, PURPOSE_FIELDS.refinancovanie);
  const unrestricted = amount(amounts, PURPOSE_FIELDS.bezucel);

  // This mirrors mortgages.utils.get_ucely on the API. Acquisition is the
  // primary purpose whenever it is present; only refinancing and unrestricted
  // purpose are compared by amount.
  if (options.forceAcquisition || acquisition > 0) return PURPOSE_FIELDS.nadobudnutie;
  if (refinancing > 0 && unrestricted > 0) {
    return unrestricted > refinancing
      ? PURPOSE_FIELDS.bezucel
      : PURPOSE_FIELDS.refinancovanie;
  }
  if (refinancing > 0) return PURPOSE_FIELDS.refinancovanie;
  if (unrestricted > 0) return PURPOSE_FIELDS.bezucel;
  return PURPOSE_FIELDS[normalizePurpose(fallbackPurpose)];
}

function getMortgagePurpose(amounts = {}, fallbackPurpose = null, options = {}) {
  const field = getMortgagePurposeField(amounts, fallbackPurpose, options);
  return Object.keys(PURPOSE_FIELDS).find((purpose) => PURPOSE_FIELDS[purpose] === field);
}

function hasRequestedAmount(amounts = {}) {
  return Object.values(PURPOSE_FIELDS).some((field) => amount(amounts, field) > 0);
}

function didMortgagePurposeChange(currentAmounts, nextAmounts, options = {}) {
  // Going from/to an empty calculation is setup, not a purpose switch.
  if (!hasRequestedAmount(currentAmounts) || !hasRequestedAmount(nextAmounts)) return false;
  return getMortgagePurposeField(currentAmounts, null, options)
    !== getMortgagePurposeField(nextAmounts, null, options);
}

module.exports = {
  PURPOSE_FIELDS,
  didMortgagePurposeChange,
  getMortgagePurpose,
  getMortgagePurposeField,
};
